import React, { useState } from 'react';
import {Grid,
        makeStyles,
        Box,
        Typography,
        Fab,
        Tooltip
} from '@material-ui/core/';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LoginModal from './Modals/LoginModal';

const useStyles = makeStyles({
    root: {
        position: 'relative',
        left: 0,
        bottom: 0,
        width: '100%',
        height: '10vh',
        background: '#80808040',
    },
    link: {
        color: 'grey',
        fontSize: 'small',
    },
    loginButtonContainer: {
        display: 'flex',
        width: '98%',
        justifyContent: 'flex-end',
        marginTop: '-60px',
    },
    loginModalContainer: {
        marginTop: '-120px',
        zIndex: 2
    }
})

function Footer({admin, API}) {
    const classes = useStyles();
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const handleOpenLoginModal = () => setIsLoginModalOpen(!isLoginModalOpen);

    const handleLogout = () => {
        localStorage.setItem('admin', JSON.stringify({}));
        window.location.reload()
    };

    return(
        <Box className={classes.root} >
             <Grid container justify='space-evenly' alignItems='center' style={{ height:'100%'}}>
                 <Grid item>
                    <Typography color='textSecondary'>
                        Chata Dolní Věstonice | 2022 | © Všechna práva vyhrazena.
                    </Typography>
                 </Grid>
             </Grid>
             <Grid container className={classes.loginButtonContainer}>
                 {
                    isLoginModalOpen &&
                        <Grid item className={classes.loginModalContainer}>
                            <LoginModal API={API} />
                        </Grid>
                 }

                 {
                 (admin && admin.username) ?
                  <Tooltip title='Odhlásit'>
                    <Fab
                        style={{ opacity: 0.5}} 
                        size='small'
                        onClick={() => handleLogout()}
                    >
                        <ExitToAppIcon />
                    </Fab>
                  </Tooltip>
                 :
                    <Fab 
                        style={{ opacity: 0.5}} 
                        size='small'
                        onClick={() => handleOpenLoginModal()}
                    >
                        <SettingsIcon />
                    </Fab>
                 }

   
             </Grid>
        </Box>
    )
}

export default Footer;